export const generatePartnersFormEmailTemplate = ({
	name,
	email,
	subject,
	description,
	message_type,
}) => {
	return {
		message_type,
		html_template: `
            <p><b>You got a new message from<b><p>
            <p>Name: ${name}</p>
            <p>Email: ${email}</p>
            <br>
            <p>Subject: ${subject}</p>
            <br>
            <p>Message</p>
            <p>${description}</p>
        `,
		from_name: name,
		from_email: email,
		from_subject: subject,
		from_description: description,
	};
};

export const generateReservationFormEmailTemplate = ({
	name,
	email,
	subject,
	description,
	phone,
	language,
	message_type,
}) => {
	return {
		message_type,
		html_template: `
            <p><b>You got a new message from<b><p>
            <p>Name: ${name}</p>
            <p>Email: ${email}</p>
            <p>Phone: ${phone}</p>
            <p>Language: ${language}</p>
            <br>
            <p>Subject: ${subject}</p>
            <br>
            <p>Message</p>
            <p>${description}</p>
        `,
		from_name: name,
		from_email: email,
		from_phone: phone,
		from_language: language,
		from_subject: subject,
		from_description: description,
	};
};

export const generateCareerFormEmailTemplate = ({
	name,
	category,
	subject,
	description,
	message_type,
}) => {
	return {
		message_type,
		html_template: `
            <p><b>You got a new message from<b><p>
            <p>Name: ${name}</p>
            <p>Category: ${category}</p>
            <br>
            <p>Subject: ${subject}</p>
            <br>
            <p>Message</p>
            <p>${description}</p>
        `,
		from_name: name,
		from_category: category,
		from_subject: subject,
		from_description: description,
	};
};

export const generateOtherFormEmailTemplate = ({
	name,
	email,
	subject,
	description,
	message_type,
}) => {
	return {
		message_type,
		html_template: `
            <p><b>You got a new message from<b><p>
            <p>Name: ${name}</p>
            <p>Email: ${email}</p>
            <br>
            <p>Subject: ${subject}</p>
            <br>
            <p>Message</p>
            <p>${description}</p>
        `,
		from_name: name,
		from_email: email,
		from_subject: subject,
		from_description: description,
	};
};
